// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e1fa9b64","453":"d703c9e9","455":"f6375928","977":"233f4b83"}[chunkId] + ".chunk.js";
};